import { get, set } from "lodash";

export const isFreeViewDataCoverageTag = 'IS_FREE_VIEW_DATA_COVERAGE'

export const setIsFreeViewDataCoverage = val => {
    set(window, isFreeViewDataCoverageTag, val);
};

export const getIsFreeViewDataCoverage = () => {
    return get(window, isFreeViewDataCoverageTag, false);
};
